import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import ReactHtmlParser from 'html-react-parser';
import { useMemo } from 'react';
import striptags from 'striptags';

import { FoodComponentMethodStep } from '../../../../libs';
import { decodeHtmlSymbols } from '../../../../libs/utils/helperFunctions';
import { generateOvenSettingsTableData } from '../ExportHelpers';

interface MethodStepRowProps {
  method: FoodComponentMethodStep;
  index: number;
}

const MethodStepRow = ({ method, index }: MethodStepRowProps) => {
  const decodedDescription = useMemo(() => decodeHtmlSymbols(method.description ?? ''), [method.description]);

  if (decodedDescription.includes('Steam %')) {
    const ovenSettingsData = generateOvenSettingsTableData(decodedDescription);
    return (
      <>
        <Typography sx={{ mb: '8px' }}>{index + 1}. Oven Settings:</Typography>
        <TableContainer
          component={Paper}
          sx={{
            border: '1px solid black',
            minWidth: '150px',
            pageBreakInside: 'avoid',
            breakInside: 'avoid'
          }}
        >
          <Table sx={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
            <TableHead>
              <TableRow>
                {Object.keys(ovenSettingsData).map((attributeName, idx) => (
                  <TableCell key={idx} sx={{ padding: '8px' }}>
                    {attributeName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                {Object.values(ovenSettingsData).map((attributeValue, idx) => (
                  <TableCell key={idx}>{attributeValue}</TableCell>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <br />
      </>
    );
  } else if (decodedDescription.includes('<table')) {
    return <>{ReactHtmlParser(decodedDescription)}</>;
  } else {
    return (
      <Typography sx={{ mb: '8px' }}>
        {index + 1}. {striptags(decodedDescription)}
      </Typography>
    );
  }
};

export default MethodStepRow;
